jQuery(document).ready(function ($) {
  // primary nav
  $('.nav-primary').accessibleNav({
    desktop: 1025,
    spans: 'hide',
    level2position: 'vertical-bottom',
    level3position: 'horizontal-right'
  });
  //Nav Functionality - Start
  $('.nav-primary .nav-toggle').click(function () {
    $('.nav-wrapper').toggleClass('open-nav');
    $('header').toggleClass('open-nav');
    // $('body').toggleClass('fixed');
    if ($('.nav-primary .ul1').is(':visible')) {
      $('.nav-toggle .fa-bars').removeClass('hide').addClass('show');
      $('.nav-toggle .fa-times').removeClass('show').addClass('hide');
      $('.nav-primary .ul1').fadeOut('slow');
    } else {
      $('.nav-toggle .fa-bars').removeClass('show').addClass('hide');
      $('.nav-toggle .fa-times').removeClass('hide').addClass('show');
      $('.nav-primary .ul1').fadeIn('slow');
    }
  });

  $('.nav-primary .nav-toggle').on('keypress', function (e) {
    $('.nav-wrapper').toggleClass('open-nav');
    $('header').toggleClass('open-nav');
    // $('body').toggleClass('fixed');
    if (e.which === 13) {
      if ($('.nav-primary .ul1').is(':visible')) {
        $('.nav-toggle .fa-bars').removeClass('hide').addClass('show');
        $('.nav-toggle .fa-times').removeClass('show').addClass('hide');
        $('.nav-primary .ul1').fadeOut('slow');
      } else {
        $('.nav-toggle .fa-bars').removeClass('show').addClass('hide');
        $('.nav-toggle .fa-times').removeClass('hide').addClass('show');
        $('.nav-primary .ul1').fadeIn('slow');
      }
    }
  });

  //Move Mobile version of top links inside mobile menu
  if ($(window).width() <= 1006) {
    $('.top-nav.mobile').each(function () {
      $(this).insertAfter($('.nav-primary .ul1 .li1:last-of-type'));
      $(this).wrap('<li></li>');
    });
  }

  //Add in ul titles for mobile menu
  if ($(window).width() < 1024) {
    $('.nav-primary .ul2').each(function () {
      title = $(this).prevAll('a').text();
      link = $(this).prevAll('a').attr('href');
      $(this).prepend('<li class="title"><span>' + title + '</span><a title="Back to main menu" tabindex="0" class="toggler open"><span class="" aria-label="Back to main menu"></span> Back</a></li>');
    });
    $('.nav-primary .ul1 > li span.toggler').on('click', function () {
      $('.nav-primary .ul1 > li, .nav-primary .ul1 > li > a').addClass('hidden');
    });
    $('.nav-primary .ul2 > li.title a.toggler.open').on('click', function () {
      $('.nav-primary .ul2, .nav-primary .ul1 li').removeClass('open');
      $('.nav-primary .ul1 > li, .nav-primary .ul1 > li > a').removeClass('hidden');
    });

    $('.nav-primary .ul1 > li span.toggler').on('keypress', function (e) {
      if (e.which === 13) {
        $('.nav-primary .ul1 > li, .nav-primary .ul1 > li > a').addClass('hidden');
      }
    });
    $('.nav-primary .ul2 > li.title a.toggler.open').on('keypress', function (e) {
      if (e.which === 13) {
        $('.nav-primary .ul2, .nav-primary .ul1 li').removeClass('open');
        $('.nav-primary .ul1 > li, .nav-primary .ul1 > li > a').removeClass('hidden');
      }
    });
  }

  // search
  $('.search-form > button').click(function (e) {
    e.preventDefault();
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $('.search-form input[type="search"]').val();
    var url = root + terms;
    // console.log(url);
    window.location.href = url;
  });
  $('.search-form input[type="search"]').on('keyup', function (e) {
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $(this).val();
    var url = root + terms;
    // console.log(url);
    if (e.which === 13) {
      window.location.href = url;
    }
  });
  $(".search-form input[type='search']").focusin(function () {
    $('.search-form').addClass('active');
  });
  $(".search-form input[type='search']").focusout(function () {
    $('.search-form').removeClass('active');
  });

  //Search Toggle - Start
  $('.search-toggle').click(function () {
    $('body').addClass('search-open');
    $('.search-box').fadeIn('slow');
    $('.search-box input').first().focus();
    $('.search-box .fa-times').click(function () {
      $('.search-box').fadeOut('slow');
      $('body').removeClass('search-open');
    });
    // find focusable items
    var searchFocusable = $('.search-box span.fa-times, .search-box .search-container a.btn-search, .search-box .search-container input');
    var searchFocusableFirst = searchFocusable.first();
    var searchFocusableLast = searchFocusable.last();
    searchFocusableLast.on('keydown', function (e) {
      if ((e.which === 9 && !e.shiftKey)) {
        e.preventDefault();
        searchFocusableFirst.focus();
      }
    });
    searchFocusableFirst.on('keydown', function (e) {
      if ((e.which === 9 && e.shiftKey)) {
        e.preventDefault();
        searchFocusableLast.focus();
      }
    });
  });

  $('.search-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      $('.search-box').slideDown('slow');
      $('.search-box input').first().focus();
      $('.search-box .fa-times').on('keypress', function (e) {
        if (e.which === 13) {
          $('.search-box').slideUp('slow');
        }
      });
      // find focusable items
      var searchFocusable = $('.search-box span.fa-times, .search-box .search-container a.btn-search, .search-box .search-container input');
      var searchFocusableFirst = searchFocusable.first();
      var searchFocusableLast = searchFocusable.last();
      searchFocusableLast.on('keydown', function (e) {
        if ((e.which === 9 && !e.shiftKey)) {
          e.preventDefault();
          searchFocusableFirst.focus();
        }
      });
      searchFocusableFirst.on('keydown', function (e) {
        if ((e.which === 9 && e.shiftKey)) {
          e.preventDefault();
          searchFocusableLast.focus();
        }
      });
    }
  });
  //Search Toggle - End

  //Fade in on scroll
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $(window).on('resize scroll', function () {
    $('.fadeIn, .fadeInUp').each(function () {
      if ($(this).isInViewport()) {
        $(this).addClass('show');
      }
    });
  });

  //If already in view, don't fade in
  $(window).on('load', function () {
    $('.fadeIn, .fadeInUp').each(function () {
      if ($(this).isInViewport()) {
        $(this).addClass('show');
      }
    });
  });

  // add class to select on open
  $('select').on('click', function () {
    $(this).toggleClass('open');
  });
  $('label').on('click', function (e) {
    if ($(this).next().is('select')) {
      e.preventDefault();
      $(this).next('select').focus();
    }
  });
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      if ($('select').hasClass('open')) {
        $(this).removeClass('open');
      }
    }
  });
  $(window).on('scroll', function () {
    if ($('select').hasClass('open')) {
      $('select').removeClass('open');
    }
  });

  //Tabs
  if ($('.tabs').length) {
    $('.tabs .tab-con').prepend('<div class="tab-toggle"></div>');
    $('.tab-toggle').click(function () {
      $(this).next('.tab-list').toggleClass('open');
      $(this).toggleClass('active');
      $('.tab-list a').click(function () {
        $('.tab-list.open').removeClass('open');
        $('.tab-toggle').removeClass('active');
      });
    });
  }

  if ($('div.hover').length) {
    $('.content-cta-image.hover').parent().addClass("hovering");
    $('.hovering').prev().addClass("hovered");
  }

  //Image Sections
  $('.image-section .image img').attr('src', function () {
    $(this).parent().css('background-image', 'url(' + $(this).attr('src') + ')');
    $(this).remove();
  });

  $('.image-section-fullwidth .image img').attr('src', function () {
    $(this).closest('.image').css('background-image', 'url(' + $(this).attr('src') + ')');
    $(this).parent().remove();
  });

  if ($(window).width() < 1024) {
    $('.tabs-nobackground.featured').each(function () {
      $('.tabs-nobackground.featured .tabs').wrapInner('<div class="tab-sections"></div>');
      $('.tabs-nobackground.featured .tabs .tab-sections .tab-con').each(function () {
        $(this).parent().parent().prepend(this);
      });
    });
  }

  //Featured Tabs
  if ($(window).width() < 1024) {
    window.addEventListener('load', function () {
      new Glider(document.querySelector('.tabs-nobackground.featured .tab-sections'), {
        slidesToShow: 1, //'auto',
        slidesToScroll: 1,
        // itemWidth: 295,
        draggable: true,
        scrollLock: true,
        dots: '.dots',
        rewind: false,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToScroll: 0,
            slidesToShow: 1,
            dots: false,
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: true,
          }
        }
        ]
      });
    });
  }

  //Featured Sphere blog posts
  if ($(window).width() < 1024) {
    window.addEventListener('load', function () {
      new Glider(document.querySelector('body.homepage.sphere .recent-posts .blog-posts'), {
        slidesToShow: 1.25, //'auto',
        slidesToScroll: 1,
        // itemWidth: 295,
        draggable: true,
        scrollLock: true,
        dots: '.sphere-dots',
        rewind: false,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToScroll: 0,
            slidesToShow: 1,
            dots: true,
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: true,
          }
        }
        ]
      });
    });
  }

  //Smooth Scroll START
  $('a[href*="#main"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000, function () {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });
  //Smooth Scroll END

});